import React from "react";
import "./Announcement.css";
import Announcement_card from "./Announcement_card/Announcement_card";
import Common_white_header from "../Common/Common_Component/Common_white_header/Common_white_header";
import No_data from "../Common/No_data/No_data";

function Announcement() {
  return (
    <>
      <section className="Announcement">
        <Common_white_header headingText={"Announcement"} />
        <div className="container">
          <Announcement_card />
          <Announcement_card />
          <Announcement_card />
          <Announcement_card />
          <Announcement_card />

           <No_data/>
        </div>
      </section>
    </>
  );
}

export default Announcement;
